import React, { useState, useEffect } from "react";
import { useHookstate } from "@hookstate/core";
import globalAuthStateStore from "../../../../../stores/globalAuthStateStore";
import { VirtualLibrarianService } from "../../../../../services/VirtualLibrarianService";
import { FormatUTCDate } from "../../../../../utilities/DateFormater";
import AccordionTable from "./AccordionTable/table";

const VirtualLibrarianChatLog = () => {
  const [chatLogs, setChatLogs] = useState([]);

  const authStore = useHookstate(globalAuthStateStore);
  const vlService = React.useMemo(
    () => new VirtualLibrarianService(authStore),
    [authStore]
  );

  useEffect(() => {
    async function fetchData() {
      const result = await vlService.getAllChatLogs();
      if (result) {
        console.log(result.Data);
        const formattedData = result?.Data?.map((f) => {
          return {
            Date: FormatUTCDate(f.StartDate),
            //Organization:
            InitialQuestion: f.Chats[0] !== undefined ? f.Chats[0].Prompt : "",
            SessionId: f.SessionId,
            User: f.UserName,
            Chats: f.Chats,
          };
        });
        console.log(formattedData);
        setChatLogs(formattedData);
      }
    }
    fetchData();
  }, []);

  const headers = [
    { title: "Date", width: "10%" },
    //{title: "Organization", width: 20},
    { title: "Initial Question", width: "50%" },
    { title: "SessionId", width: "20%" },
    { title: "User", width: "17%" },
  ];

  return (
    <div className="vl-content-wrapper">
      <h4>Admin Review</h4>
      <AccordionTable headers={headers} data={chatLogs} />
    </div>
  );
};

export default VirtualLibrarianChatLog;
